import { Component, Input } from '@angular/core';
import { StoreService } from '@app/shared/services/store.service';

@Component({
    selector: 'app-block-features',
    templateUrl: './block-features.component.html',
    styleUrls: ['./block-features.component.scss']
})
export class BlockFeaturesComponent {
    @Input() layout: 'classic'|'boxed' = 'classic';

    constructor(public store: StoreService) { }
}
